import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useDrawingManager } from './useDrawingManager';
export * from './useDrawingManager';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    drawingManager
  } = useDrawingManager(props);
  useImperativeHandle(ref, () => _extends({}, props, {
    drawingManager,
    BMapLib: window.BMapLib
  }));
  return null;
});